<script setup>
import {computed, watch} from "vue";
import WizardButton from "../../../components/ui-components/WizardButton.vue";
import Button from "primevue/button";
import {usePage} from "@inertiajs/vue3";
import GoogleIcon from "../../../../login/components/GoogleIcon.vue";

const props = usePage().props;
const valid = defineModel('valid');
const model = defineModel()
const needsLogin = computed(() => {
    if (props.user) {
        switch (model.value.calendarProvider) {
            case 'google':
                return props.user.google_id !== null;
            case 'microsoft':
                return props.user.microsoft_id !== null;
            default:
                return false;
        }
    }
    return props.user;
})

watch(() => model.value.calendarProvider, (now) => {
    valid.value = needsLogin.value && ['google', 'microsoft'].includes(now)
}, {immediate: true, deep: true})

const connectAccounts = () => {
    document.location.href = '/connect/' + model.value.calendarProvider + '/calendar';
}
</script>

<template>
    <div class="flex flex-col gap-5 pb-6 pt-4">
        <div class="flex flex-col gap-4 items-start">
            <wizard-button @select="model.calendarProvider = 'google'" :active="model.calendarProvider==='google'"
                           :title="$t('forms.calendar_google_title')">
                <template #icon>
                    <span class="w-[30px] h-[30px] p-2 bg-gray-200 dark:bg-gray-800 rounded">
                        <google-icon></google-icon>
                    </span>
                </template>
            </wizard-button>
            <wizard-button @select="model.calendarProvider = 'microsoft'" :active="model.calendarProvider==='microsoft'"
                           icon="pi pi-microsoft" title="Microsoft 365"></wizard-button>
        </div>
        <div v-if="model.calendarProvider && !needsLogin">
            <p class="mb-4">{{ $t('forms.calendar_not_connected_select', { provider: model.calendarProvider[0].toUpperCase() + model.calendarProvider.slice(1) }) }}
                <span class="font-bold">{{ $t('forms.calendar_connect_warning') }}</span></p>
            <Button severity="secondary" :icon="'pi pi-'+model.calendarProvider" :label="$t('forms.calendar_connect_btn')"
                    @click="connectAccounts"></Button>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
